document.addEventListener("DOMContentLoaded", async () => {
  document.querySelectorAll(".bio-container").forEach((bio) => {
    const textElement = bio.querySelector(".bio-text");
    const toggleBtn = bio.querySelector(".toggle-btn");

    const fullText = textElement.dataset.full.trim();
    const words = fullText.split(/\s+/);

    if (words.length > 25) {
      const shortText = words.slice(0, 25).join(" ") + "...";
      textElement.textContent = shortText;
      toggleBtn.textContent = "See more";

      let expanded = false;
      toggleBtn.addEventListener("click", () => {
        expanded = !expanded;
        if (expanded) {
          textElement.textContent = fullText;
          toggleBtn.textContent = "See less";
        } else {
          textElement.textContent = shortText;
          toggleBtn.textContent = "See more";
        }
      });
    } else {
      textElement.textContent = fullText;
      toggleBtn.style.display = "none";
    }
  });

  const btnTab = document.querySelectorAll(".btn-tab");
  const tabContents = document.querySelectorAll(".tab-content");
  btnTab.forEach((button) => {
    button.addEventListener("click", () => {
      // Remove active from all
      btnTab.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Activate clicked button and matching content
      button.classList.add("active");
      document.getElementById(button.dataset.tab).classList.add("active");
    });
  });

  const el = document.getElementById("metafield-tracklist");
  console.log(el);
  if (!el) return;
  const raw = el.dataset.tracklist;

  try {
    const data = JSON.parse(raw);
    if (!data.Track) return;

    data.Track.sort((a, b) => {
      const discA = Number(a["@Disc"]);
      const discB = Number(b["@Disc"]);
      const trackA = Number(a["@Track"]);
      const trackB = Number(b["@Track"]);

      if (discA !== discB) {
        return discA - discB;
      }
      return trackA - trackB;
    });

    let html = "";
    data.Track.forEach((track) => {
      html += `<div class="track-item">
        ${track["@Disc"]}.${track["@Track"]} ${track["@Title"]}
      </div>`;
    });

    el.innerHTML = html;
  } catch (err) {
    console.error("JSON parse failed:", err, raw);
  }
});
